import { Navigate, useLocation } from "react-router-dom";
import { useAuth, isAdmin } from "@/lib/auth";

export function ProtectedAdminRoute({ children }: { children: React.ReactNode }) {
  const { session, status } = useAuth();
  const location = useLocation();
  const loading = status === "loading";

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <span className="text-sm text-muted-foreground">Loading…</span>
      </div>
    );
  }

  if (!session || !isAdmin(session)) {
    const callback = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/admin/signin?callbackUrl=${encodeURIComponent(callback)}`}
        replace
      />
    );
  }

  return <>{children}</>;
}
